module.exports = __webpack_public_path__ + "img/social2.695ad63d.png";